import { render, staticRenderFns } from "./LayoutSwitchButtonComponent.vue?vue&type=template&id=27dedccf&scoped=true&"
import script from "./LayoutSwitchButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./LayoutSwitchButtonComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dedccf",
  null
  
)

export default component.exports